// Constants
import { PURCHASES } from 'constants/routes';

/** Tabs are matched by position, so this must follow the tab order in Purchase.tsx. */
export const TICKETS_TAB_INDEX = 5;

export const MY_TICKETS = `${PURCHASES}?tab=${TICKETS_TAB_INDEX}`;
